import Vue from 'vue'
import VueAMap from 'vue-amap'
import { lazyAMapApiLoaderInstance } from 'vue-amap';
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/assets/bjba/iconfont/iconfont.css'
import './plugins/axios.js'
import './permission'
import './scss/global.scss'
import './mock'
import moment from 'moment'
import { Component } from 'vue-property-decorator'
import i18n from './i18n'
import './icon/iconfont.css'
import * as echarts from 'echarts'
import 'echarts-liquidfill'
import request from './utils/request'
import Fragment from 'vue-fragment'
import {isAuth} from './utils/user'
import {setQueryConfig} from './utils/user'
import {CONST_ZN_BM} from './utils/user'
import Ueditor from './components/ueditor'
import 'core-js';
import "regenerator-runtime/runtime";
import FileUpload from "./components/FileUpload/index"
import "@/assets/font/font.css"
import './utils/directive.js';

import {
  UTableColumn,
  UTable,
  UxGrid,
  UxTableColumn
} from 'umy-ui';
Vue.use(Fragment.Plugin)
Vue.use(Ueditor)
Vue.use(VueAMap)
Vue.use(UTableColumn);
Vue.use(UTable);
Vue.use(UxGrid);
Vue.use(UxTableColumn);
Vue.use(FileUpload);
Object.keys(localStorage).forEach(item => item.indexOf('_AMap') != -1 ? localStorage.removeItem(item) :'')
VueAMap.initAMapApiLoader({
  key: '4a1bb32a7f10e6e6fd440f579009939f',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation','AMap.PolyEditor', 'AMap.CircleEditor','AMap.MarkerClusterer'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})
Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
Vue.prototype.$request = request
Vue.prototype.isAuth = isAuth
Vue.prototype.setQueryConfig = setQueryConfig
Vue.prototype.CONST_ZN_BM = CONST_ZN_BM
import { downBlobFile } from '@/utils/utils'
Vue.prototype.downBlobFile = downBlobFile
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate'])

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
